import { render, staticRenderFns } from "./PurchaseDetail.vue?vue&type=template&id=48929680&scoped=true&"
import script from "./PurchaseDetail.vue?vue&type=script&lang=js&"
export * from "./PurchaseDetail.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseDetail.vue?vue&type=style&index=0&id=48929680&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48929680",
  null
  
)

export default component.exports